// True when a credit pull returned a valid summary XML that contains no MISMO data,
// i.e. the 700Credit account does not have MISMO XML enabled. Error payloads
// (<error>/<HX5>) are excluded because they indicate a failed pull, not a missing MISMO feed.
export const isMissingMismoXml = (creditSummaryXml: string | undefined | null): boolean => {
  if (!creditSummaryXml || creditSummaryXml.trim() === '') {
    return false;
  }
  if (creditSummaryXml.includes('MISMO')) {
    return false;
  }
  if (creditSummaryXml.includes('<error>') || creditSummaryXml.includes('<HX5>')) {
    return false;
  }
  const doc = new DOMParser().parseFromString(creditSummaryXml, 'application/xml');
  return doc.getElementsByTagName('parsererror').length === 0;
};
